import opalOrb from '@frontend/assets/opal.png';

// `filled` is accepted and ignored: NavigationItem clones every nav icon with a
// `filled` flag meant for Axiom glyph icons, which the raster orb has no use for.
//
// Size must be inline style, not width/height attrs: Axiom's <Icon> applies
// height:16px as author CSS, which overrides HTML presentation attrs (shrinking
// the orb to 16px) but loses to inline style.
export const OpalOrbIcon = (_: { filled?: boolean }) => (
  <img
    src={opalOrb}
    alt=""
    aria-hidden="true"
    style={{ display: 'block', height: 24, width: 24 }}
  />
);
